import React from 'react';

function SouthKorea(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124081)">
        <mask
          id="mask0_800_124081"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124081)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124081"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124081)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 18.2195C21.6031 18.2195 24.5239 15.4622 24.5239 12.061C24.5239 8.65971 21.6031 5.90244 18 5.90244C14.3969 5.90244 11.4761 8.65971 11.4761 12.061C11.4761 15.4622 14.3969 18.2195 18 18.2195Z"
              fill="#3D58DB"
            />
            <mask
              id="mask2_800_124081"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="11"
              y="5"
              width="14"
              height="14"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 18.2195C21.6031 18.2195 24.5239 15.4622 24.5239 12.061C24.5239 8.65971 21.6031 5.90244 18 5.90244C14.3969 5.90244 11.4761 8.65971 11.4761 12.061C11.4761 15.4622 14.3969 18.2195 18 18.2195Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124081)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.7522 12.5327C24.7522 12.5327 24.386 9.62879 21.674 9.47114C18.962 9.3135 18.2307 11.6007 18.0742 12.2067C17.9177 12.8127 17.5216 14.4292 14.6662 14.4292C11.8108 14.4292 11.5532 10.3187 11.5532 10.3187V5.47191H24.7522V12.5327Z"
                fill="#E31D1C"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.21169 2.05217L9.24103 2.8797L4.47074 7.8316L3.44141 7.00407L8.21169 2.05217ZM9.9094 3.39133L10.9387 4.21885L6.33944 9.09902L5.3101 8.27149L9.9094 3.39133ZM12.6286 5.57451L11.5992 4.74699L6.98717 9.66419L8.0165 10.4917L12.6286 5.57451Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.534 1.70518L27.5044 2.52961L29.2903 4.39245L30.3198 3.56802L28.534 1.70518ZM31.7083 5.13182L30.6788 5.95625L32.4646 7.81909L33.4941 6.99466L31.7083 5.13182ZM24.1064 5.2128L25.1359 4.38837L26.9217 6.25121L25.8922 7.07564L24.1064 5.2128ZM28.3101 7.81501L27.2806 8.63944L29.0664 10.5023L30.096 9.67784L28.3101 7.81501ZM25.8698 3.8312L26.8993 3.00677L31.8703 8.38763L30.8407 9.21206L25.8698 3.8312Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.3116 14.2431L28.2734 13.4155L26.4725 15.2856L27.5108 16.1132L29.3116 14.2431ZM26.2839 17.5341L25.2457 16.7065L23.4448 18.5766L24.483 19.4042L26.2839 17.5341ZM31.5521 16.0328L32.5904 16.8605L30.7895 18.7306L29.7513 17.9029L31.5521 16.0328ZM29.7107 20.2278L28.6725 19.4001L26.8716 21.2702L27.9098 22.0979L29.7107 20.2278ZM26.9622 17.978L28.0004 18.8057L26.1206 20.8026L25.0824 19.975L26.9622 17.978ZM31.0845 15.4782L30.0463 14.6506L28.1665 16.6475L29.2047 17.4752L31.0845 15.4782Z"
              fill="#272727"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.20725 14.8899L8.23686 14.0645L12.832 18.745L11.8024 19.5703L7.20725 14.8899ZM8.27916 18.9835L9.30877 18.1582L11.2497 20.0538L10.2201 20.8791L8.27916 18.9835ZM4.84805 16.6908L3.81844 17.5161L8.43746 22.2595L9.46707 21.4342L4.84805 16.6908ZM5.58053 16.1522L6.61014 15.3269L8.29277 17.0807L7.26316 17.9061L5.58053 16.1522Z"
              fill="#272727"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124081">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SouthKorea;
